<template>
  <Row type="flex" justify="center" class="asset-classes-section">
    <Col span="24">
      <!-- <h1>Centralized your reporting for your Entire Portfolio, Across all Entities</h1> -->
      <Row type="flex" align="middle" justify="space-between">
          <span><Icon class="green" type="ios-checkmark-outline"></Icon> Private Equity</span>
          <span><Icon class="green" type="ios-checkmark-outline"></Icon> Lending</span>
          <span><Icon class="green" type="ios-checkmark-outline"></Icon> Real Estate</span>
          <span><Icon class="green" type="ios-checkmark-outline"></Icon> Personal Property</span>
          <span><Icon class="green" type="ios-checkmark-outline"></Icon> Currencies</span>
          <span><Icon class="green" type="ios-checkmark-outline"></Icon> Marketable Securities</span>
      </Row>
<!--       <Row type="flex" justify="center">
        <h1 class="low-title">Centralized Reporting for your Entire Portfolio</h1>
      </Row> -->
    </Col>
  </Row>  
</template>
<script>
export default {

};
</script>
<style lang="css" scoped>
.asset-classes-section {
  background: rgb(44, 56, 73);
  color: #fff;
  padding: 28px 5vw;
  /*padding-top: 16px;*/
}

.low-title {
  font-size: 1rem;
}

span {
  padding: 8px;
  font-size: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/AssetTypesSection.vue